module.exports = __webpack_public_path__ + "img/沐浴.3f27b353.webp";